import {
   VideoConsultationNotificationConfigurationQuery,
   VideoConsultationNotificationConfigurationUpdateCommand,
   VideoConsultationReminderNotificationConfigurationQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

import { patientPhoneNotificationTranslationKeys } from '../../../../translations';

import {
   PatientPhoneNotificationVideoConsultationReminderConfigurationFormBean,
   PatientPhoneNotificationVideoConsultationReminderConfigurationFormController,
} from './PatientPhoneNotificationVideoConsultationReminderConfigurationForm.types';

const t = patientPhoneNotificationTranslationKeys.videoConsultationConfiguration.modal.actions.save;

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButtonProps = {
   onSuccess: VoidFunction;
} & Pick<PatientPhoneNotificationVideoConsultationReminderConfigurationFormController, 'handleSubmit'>;

export const PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButton = (
   props: PatientPhoneNotificationVideoConsultationReminderConfigurationModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: updateVideoConsultationNotificationConfiguration } = useCqrsCommand<
      void,
      PatientPhoneNotificationVideoConsultationReminderConfigurationFormBean
   >(
      (parameters) => {
         const command = new VideoConsultationNotificationConfigurationUpdateCommand();
         command.earlyNotificationEnabled = parameters.earlyNotificationEnabled;
         command.cancellationAfterEarlyNotificationEnabled = parameters.cancellationAfterEarlyNotificationEnabled;
         command.lateNotificationEnabled = parameters.lateNotificationEnabled;
         command.cancellationAfterLateNotificationEnabled = parameters.cancellationAfterLateNotificationEnabled;
         return command;
      },
      {
         onSuccess: async () => {
            props.onSuccess();
            await refetchCqrsQuery(VideoConsultationReminderNotificationConfigurationQuery);
            await refetchCqrsQuery(VideoConsultationNotificationConfigurationQuery);
            return dispatchSnackbarPositiveEvent(t.successMessage);
         },
      }
   );

   return (
      <ModalConfirmButton
         label={t.label}
         onClick={props.handleSubmit(updateVideoConsultationNotificationConfiguration)}
      />
   );
};
